export default __webpack_public_path__ + "e5a5cdd39299d8371fe3c996cd3ed675.png";